import { Button, type ButtonProps, cn } from '@seen/ui'
import { forwardRef } from 'react'

export type FacesheetCardActionButtonProps = Omit<
  ButtonProps,
  'variant' | 'size'
>

// An icon button in a card's actions cluster. A bordered, shadowed circle so it
// reads as a button rather than a stray glyph — the emphasis FacesheetCardIcon
// gives up. Forwards its ref because most callers hand it to a
// combobox/popover trigger via `asChild`.
export const FacesheetCardActionButton = forwardRef<
  HTMLButtonElement,
  FacesheetCardActionButtonProps
>(({ className, children, ...delegated }, ref) => (
  <Button
    ref={ref}
    variant="outline"
    size="unstyled"
    className={cn('size-6 shrink-0 rounded-full [&_svg]:size-3.5', className)}
    {...delegated}
  >
    {children}
  </Button>
))

FacesheetCardActionButton.displayName = 'FacesheetCardActionButton'
